import { render, staticRenderFns } from "./vagas-abrigos.vue?vue&type=template&id=0610f2c9&"
import script from "./vagas-abrigos.vue?vue&type=script&lang=js&"
export * from "./vagas-abrigos.vue?vue&type=script&lang=js&"
import style0 from "./vagas-abrigos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports